import React from 'react';
import BaseDetailPage from '../../_CustomComponents/BaseDetailPage';
import ReactToPrint from "react-to-print";
import { Navigate } from "react-router-dom";
import { addDays } from 'date-fns';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import * as programCrud from '../../../../crud/program.crud';
import * as contractCrud from '../../../../crud/contracts.crud';
import * as fileCrud from '../../../../crud/file.crud';
import axios from 'axios';
import ActionModal from '../../_CustomComponents/ActionModal';
import ProgrammeDocument from './Document';
import ReplyDocument from './DocumentReply';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { Alert } from "react-bootstrap";
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import moment from 'moment';
import Relations from '../../_CustomComponents/Relation/Relations';
import { FormattedMessage } from "react-intl";
import PageToolbar from '../../_CustomComponents/PageToolbar';
import Common from '../../../../shared/common';
import { withDetailPageProps } from '../../../../shared/hoc/withDetailPageProps';
import NavigationBlocker from '../../../../partials/Tools/NavigationBlocker';
import EmailNotifications from '../../_CustomComponents/EmailNotifications';
import NotificationContext from '../../../../../notificationContext';
import { confirm, alert as dxAlert } from 'devextreme/ui/dialog';

const initialState = {
    notification: null,
    files: null,
    showModal: false,
    saving: false,
    // isDxFormValid: true,
    isChanged: false,
    //NEW REPLY STATES
    reply: null,
    replyFiles: null,
    isAwaitingReply: false,
    modalTitle: '',
    modalText: '',
    modalMode: '',
    relationCount: 0,
    postActionUrl: null,
    relations: null,
    selectedClause: null,
    selectedReply: null
};

class ProgrammeDetail extends BaseDetailPage {
    constructor(props) {
        super(props);

        this.isRelationsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true' || process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true';
        this.printIssueDivRef = React.createRef();
        this.printAcceptanceDivRef = React.createRef();
        //NEW REPLY
        this.validatorRef = React.createRef();
        this.validatorName = 'ProgramValidator';


        const rejectOptionsPH = props.placeholders.find(ph => ph.replacementKey === 'ReplyRejectOptions');
        if (rejectOptionsPH) {
            this.rejectOptions = rejectOptionsPH.values.filter(item => item.isActive === true);
        }


        this.state = { ...initialState };
    }

    static contextType = NotificationContext;
    
    componentDidMount() {
        this.fetchProgramme();
        this.fetchFiles();
        this.fetchReplyFiles();
    }

    componentWillUnmount() {
        this.context.updateNotificationContext({
            documentIsFinal: false,
            path: null,
            referenceId: null,
            referenceType: null,
            workflowGroupId: null,
            workflowId: null,
        });
    }

    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.setState({ ...initialState }, () => {
                this.fetchProgramme();
                this.fetchFiles();
                this.fetchReplyFiles();
            });
        }
    }

    getMailDescription = () => {
        return this.state.notification.reference;
    }
    getSelectedTypeClauseDisplay = () => {
        return this.state.notification.type;
    }
    fetchProgramme = async () => {
        await this.props.closeSnackbar('PersistentFormWarning');
        const { fields } = this.props.workflowItem;
        programCrud.getProgram(this.props.params.notificationid)
            .then(response => {
                const programme = response.data;
                if (programme.contractid !== this.props.contract.contractid) {
                    throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.INVALID_URL' }));
                }
                if (programme.previousplanneddate && fields.PreviousPlanned.visible) {
                    programme.previousplanneddate = new Date(programme.previousplanneddate);
                }

                if (this.props.contract.expectedcompletiondate && fields.PreviousPlanned.visible) {
                    const contractCompletionDate = new Date(this.props.contract.expectedcompletiondate);
                    //HANDLE THE CASE CONTRACT PLANNED DATE VALUE HAS BEEN UPDATED SINCE THIS NOTIFICATION DRAFTED
                    if (programme.showtasknotification !== 1 && !moment(contractCompletionDate).isSame(programme.previousplanneddate, 'day')) {
                        programme.previousplanneddate = contractCompletionDate;
                        this.props.enqueueSnackbar('Form fields has been updated due to contract completion date change', { variant: 'warning', key: 'PersistentFormWarning', persist: true });
                    }
                }
                if (fields.PlannedCompletion.visible) {
                    programme.plannedcompletiondate = new Date(programme.plannedcompletiondate);
                }
                if (programme.draftreplydate) {
                    programme.draftreplydate = new Date(programme.draftreplydate);
                }

                const awaitingReply = (programme.showtasknotification === 1 &&
                    ["Awaiting Acceptance", "ADAP"].includes(programme.status) &&
                    this.props.workflowItem.replyEnabled);


                let selectedClause = null;
                if (programme.type && fields.Type.clauses) {
                    selectedClause = fields.Type.clauses.find(c => c.display === programme.type);
                    if (selectedClause) {
                    }
                    else {
                        if (programme.showtasknotification !== 1) {
                            programme.type = null;
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_CLAUSE_MISSING' }), { variant: 'warning', });
                        }
                    }
                }

                const replyItem = {
                    status: programme.draftprogrammestatus,
                    comments: programme.draftreplycomment,
                    plansnotpractical: programme.draftplansnotpractical === 1,
                    missingcontractrequires: programme.draftmissingcontractrequires === 1,
                    notrepresentplan: programme.draftnotrepresentplan === 1,
                    notcomply: programme.draftnotcomply === 1,
                    rejectcustomreason1: programme.draftrejectcustomreason1 === 1,
                    rejectcustomreason2: programme.draftrejectcustomreason2 === 1,
                    customfieldvalues: programme.customfieldvalues
                };

                this.setState({
                    notification: programme,
                    reply: replyItem,
                    isAwaitingReply: awaitingReply,
                    saving: false,
                    isChanged: false,
                    relations: programme.relations,
                    relationCount: Common.GetRelationCount(programme, this.props.accessibleWfIds)
                }, () => { 
                    this.props.setReference(this.state.notification.referenceid);
                    this.context.updateNotificationContext({
                        documentIsFinal: programme.showtasknotification === 1,
                        path: this.props.location.pathname,
                        referenceId: this.props.params.notificationid,
                        referenceType: this.props.workflowItem.config.referenceType,
                        workflowGroupId: this.props.workflowGroupItem.id,
                        workflowId: this.props.workflowItem.id,
                    });
                });
            })
            .catch(err => {
                if (!axios.isCancel(err)) {
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            });
    }

    fetchFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType)
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    fetchReplyFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType + 'Reply')
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ replyFiles: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    printHandler = () => {
        this.printIssueRef.handlePrint();
    }

    printAcceptanceHandler = () => {
        this.printAcceptanceRef.handlePrint();
    }
    validateForm = async (mode) => {
        const validationResult = this.validatorRef.current.instance().validate();

        if (!validationResult.isValid) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_MISSING_FIELDS' }), { variant: 'warning', });
        }

        if (mode === 'COMMUNICATE' && !this.state.fileCount) {
            if (this.props.mandateAttachment) {
                await this.mandateAttachment();

                return false; // stop communication
            } else if (this.props.warnAttachment) {
                const response = await this.warnAttachment();

                if (!response) {
                    return false; //cancelled
                }
            }
        }

        return validationResult.isValid && !this.state.saving;
    }

    mandateAttachment = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'CONTRACT.WF.PROGRAMME.WARNING.ATTACHMENT_REQUIRED_MESSAGE' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CONTRACT.WF.PROGRAMME.WARNING.ATTACHMENT_TITLE' });

        await dxAlert(`<div style="max-width:50vw;">${warningMessage}</div>`, warningMessageTitle);
    }

    warnAttachment = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'CONTRACT.WF.PROGRAMME.WARNING.ATTACHMENT_WARNING_MESSAGE' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CONTRACT.WF.PROGRAMME.WARNING.ATTACHMENT_TITLE' });

        return confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
    }

    showModal = async (mode, postActionNavigateObj) => {
        let selectedClause = null;
        const { fields } = this.props.workflowItem;
        if (this.state.notification.type && fields.Type.clauses) {
            selectedClause = fields.Type.clauses.find(c => c.display === this.state.notification.type);
        }
        if (mode === 'COMMUNICATE') {
            if (await this.validateForm(mode)) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM' }, { ITEM_NAME: this.props.title }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_COMMUNICATING' }, { ITEM_NAME: this.props.title }),
                    modalMode: mode,
                    postActionUrl: postActionNavigateObj,
                    selectedClause
                });
            }
        }
        else if (mode === 'SAVE_DRAFT') {
            if (this.validateForm(mode)) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'DELETE_DRAFT') {
            this.setState({
                showModal: true,
                modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DELETE_DRAFT_NOTIFY' }),
                modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_DELETING' }),
                modalMode: mode,
            });
        }
        else if (mode === 'REPLY_DRAFT') {
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm(mode)) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'REPLY_SEND') {
            let selectedReply = null;
            const { replyFields } = this.props.workflowItem;
            if (this.state.reply.status && replyFields.Status.replyOptions) {
                selectedReply = replyFields.Status.replyOptions.find(c => c.field === this.state.reply.status);
            }
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm(mode)) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SEND_REPLY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_SENDING' }),
                    modalMode: mode,
                    selectedClause,
                    selectedReply
                });
            }
        }
    }

    onModalResponse = (response, params) => {
        const { fields } = this.props.workflowItem;
        this.setState({ showModal: false, saving: response === 'OK' }, async () => {
            try {
                if (response === 'OK') {
                    let selectedClause = null;
                    if (fields.Type.visible) {
                        selectedClause = fields.Type.clauses.find(item => item.display === this.state.notification.type);
                        if (!selectedClause) {
                            console.log("Clause selection not found!");
                        }
                    }
                    if (this.state.modalMode === 'COMMUNICATE') {
                        const programme = { ...this.state.notification };
                        programme.createactions = params?.createactions;
                        programme.completeactions = params?.completeactions;




                        if (programme.previousplanneddate && fields.PreviousPlanned.visible) {
                            programme.previousplanneddatedisplay = moment(programme.previousplanneddate).format('DD/MM/YYYY');
                        }
                        if (fields.PlannedCompletion.visible) {
                            programme.plannedcompletiondatedisplay = moment(programme.plannedcompletiondate).format('DD/MM/YYYY');
                        }

                        //#TODO: MOVE THIS CHECK FROM UI TO API
                        const { data: contractDetails } = await contractCrud.getContract(this.props.contract.contractid);
                        if (contractDetails.expectedcompletiondate && fields.PreviousPlanned.visible) {
                            const contractCompletionDate = new Date(contractDetails.expectedcompletiondate);
                            if (!moment(contractCompletionDate).isSame(programme.previousplanneddate, 'day')) {
                                throw new Error(this.props.intl.formatMessage({ id: 'CONTRACT.WF.PAYMENT.WARNING.RECALCULATED_REFRESH' }))
                            }
                        }
                        programme.showtasknotification = 1;

                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            programme.status = 'Communicated';
                            programme.isreplyrequired = false;
                            programme.replyrequireddate = null;
                            programme.replyrequireddatedisplay = null;
                        }
                        else {
                            programme.isreplyrequired = true;
                            programme.status = 'Awaiting Acceptance';
                            let replyPeriod = this.props.workflowItem.replyPeriod;
                            if (selectedClause && selectedClause.applyReplyPeriod && selectedClause.hasOwnProperty("replyPeriod")) {
                                replyPeriod = selectedClause.replyPeriod;
                            }
                            programme.replyrequireddatedisplay = moment(addDays(new Date(), replyPeriod)).format('DD/MM/YYYY');

                            //ASSIGN RESUBMIT DAYS
                            programme.resubmitperiodindays = this.props.workflowItem.resubmitPeriod;
                            if (selectedClause && selectedClause.applyResubmitPeriod && selectedClause.hasOwnProperty("resubmitPeriod")) {
                                programme.resubmitperiodindays = selectedClause.resubmitPeriod;
                            }
                        }
                        const docBodyConfig = this.documentBodyConfig(programme, this.props.resources);
                        const docConfig = await this.documentConfig(programme, docBodyConfig, this.props.contractUser.name, false, null, null, this.props.workflowItem.form_NotifyCompanyName);
                        programme.pdfjsoncontent = JSON.stringify(docConfig);

                        this.saveProgramme(programme, this.state.modalMode);

                    }
                    else if (this.state.modalMode === 'SAVE_DRAFT') {
                        const programme = { ...this.state.notification };
                        if ((params || {}).userid) {
                            programme.lastdraftednotifiedto = params.userid;
                        }
                        if (programme.previousplanneddate && fields.PreviousPlanned.visible) {
                            programme.previousplanneddatedisplay = moment(programme.previousplanneddate).format('DD/MM/YYYY');
                        }
                        if (fields.PlannedCompletion.visible) {
                            programme.plannedcompletiondatedisplay = moment(programme.plannedcompletiondate).format('DD/MM/YYYY');
                        }

                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            programme.replyrequireddate = null;
                            programme.replyrequireddatedisplay = null;
                        }
                        this.saveProgramme(programme, this.state.modalMode, params ? params.userid : null);

                    }
                    else if (this.state.modalMode === 'DELETE_DRAFT') {
                        const program = { ...this.state.notification };
                        const programid = program.programid
                        this.deleteProgramDraft(programid);

                    }
                    else if (this.state.modalMode === 'REPLY_DRAFT') {
                        const reply = { ...this.state.reply };
                        const programme = { ...this.state.notification };
                        const isAccepted = reply.status === 'Accepted';
                        programme.draftprogrammestatus = reply.status;
                        programme.draftreplycomment = reply.comments;

                        programme.draftplansnotpractical = reply.plansnotpractical && !isAccepted ? 1 : 0;
                        programme.draftmissingcontractrequires = reply.missingcontractrequires && !isAccepted ? 1 : 0;
                        programme.draftnotrepresentplan = reply.notrepresentplan && !isAccepted ? 1 : 0;
                        programme.draftnotcomply = reply.notcomply && !isAccepted ? 1 : 0;
                        programme.draftrejectcustomreason1 = reply.rejectcustomreason1 && !isAccepted ? 1 : 0;
                        programme.draftrejectcustomreason2 = reply.rejectcustomreason2 && !isAccepted ? 1 : 0;

                        // programme.draftreplystatus = 'Drafted';
                        // programme.draftreplybyid = this.props.contractUser.accountid;
                        if ((params || {}).userid) {
                            programme.draftreplytoid = params.userid;
                        }
                        programme.draftreplydatedisplay = moment().format('DD/MM/YYYY');
                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                programme[key] = reply[key];
                            }
                        }
                        this.saveProgramme(programme, this.state.modalMode, (params || {}).userid);

                    }
                    else if (this.state.modalMode === 'REPLY_SEND') {
                        const reply = { ...this.state.reply };
                        if (!this.replyValidation(reply)) {
                            //FINAL REPLY FIELDS CHECK FAILED
                            throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_FIELDS_MISSING' }))
                        }
                        const programme = { ...this.state.notification };
                        const isAccepted = reply.status === 'Accepted';
                        programme.createactions = params?.createactions;
                        programme.completeactions = params?.completeactions;
                        programme.status = reply.status;
                        programme.comments = reply.comments;

                        const rejectOptions = {
                            plansnotpractical: reply.plansnotpractical && !isAccepted ? 1 : 0,
                            missingcontractrequires: reply.missingcontractrequires && !isAccepted ? 1 : 0,
                            notrepresentplan: reply.notrepresentplan && !isAccepted ? 1 : 0,
                            notcomply: reply.notcomply && !isAccepted ? 1 : 0,
                            rejectcustomreason1: reply.rejectcustomreason1 && !isAccepted ? 1 : 0,
                            rejectcustomreason2: reply.rejectcustomreason2 && !isAccepted ? 1 : 0,
                        }


                        if (programme.previousplanneddate && fields.PreviousPlanned.visible) {
                            programme.previousplanneddatedisplay = moment(programme.previousplanneddate).format('DD/MM/YYYY');
                        }
                        if (fields.PlannedCompletion.visible) {
                            programme.plannedcompletiondatedisplay = moment(programme.plannedcompletiondate).format('DD/MM/YYYY');
                        }

                        programme.replyrequireddatedisplay = moment(new Date(programme.replyrequireddate)).format('DD/MM/YYYY');
                        // programme.replybyid = this.props.contractUser.accountid;
                        // programme.replydatedisplay = moment().format('DD/MM/YYYY');
                        programme.notcomply = rejectOptions.notcomply;
                        programme.notrepresentplan = rejectOptions.notrepresentplan;
                        programme.missingcontractrequires = rejectOptions.missingcontractrequires;
                        programme.plansnotpractical = rejectOptions.plansnotpractical;
                        programme.rejectcustomreason1 = rejectOptions.rejectcustomreason1;
                        programme.rejectcustomreason2 = rejectOptions.rejectcustomreason2;

                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                programme[key] = reply[key];
                            }
                        }
                        const docReplyBodyConfig = this.documentReplyBodyConfig(programme, this.props.resources);
                        const docReplyConfig = await this.documentConfig(programme, docReplyBodyConfig, this.props.contractUser.name, true, null, null, this.props.workflowItem.form_ReplyCompanyName);
                        programme.pdfreplyjsoncontent = JSON.stringify(docReplyConfig);

                        this.saveProgramme(programme, this.state.modalMode);

                    }

                }
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                this.setState({ saving: false });
            }

        });
    }
    replyValidation = (reply) => {
        if (!reply.status) { return false; }
        if (!reply.comments) { return false; }
        return true;
    }
    documentBodyConfig = (notification, resources) => {
        const { fields } = this.props.workflowItem;
        const config = [];
        if (resources.NotificationClause) {
            config.push({ value: resources.NotificationClause });
        }
        config.push({ label: fields.Reference.label, value: notification.reference });

        if (fields.Type.visible) {
            config.push({ label: fields.Type.label, value: notification.type });
        }

        if (notification.previousplanneddate && fields.PreviousPlanned.visible) {
            config.push({ label: fields.PreviousPlanned.label, value: notification.previousplanneddate });
        }
        if (fields.PlannedCompletion.visible) {
            config.push({ label: fields.PlannedCompletion.label, value: notification.plannedcompletiondate });
        }
        if (fields.Reason.visible) {
            config.push({ label: fields.Reason.label, value: notification.reasonchanged, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.Change.visible) {
            config.push({ label: fields.Change.label, value: notification.details, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.MainProgress.visible) {
            config.push({ label: fields.MainProgress.label, value: notification.mainprogress, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.KeyActivities.visible) {
            config.push({ label: fields.KeyActivities.label, value: notification.keyactivities, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.Summary.visible) {
            config.push({ label: fields.Summary.label, value: notification.summarycritical, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.Changes.visible) {
            config.push({ label: fields.Changes.label, value: notification.mainchanges, valueType: 'HTML', align: 'vertical' });
        }
        if (fields.Compensation.visible) {
            config.push({ label: fields.Compensation.label, value: notification.compensationevents, valueType: 'HTML', align: 'vertical' });
        }

        return config;
    }
    documentReplyBodyConfig = (notification, resources) => {
        const { replyFields } = this.props.workflowItem;
        let statusDisplay = "UNKNOWN";
        const { fields } = this.props.workflowItem;
        const selectedReply = replyFields.Status.replyOptions.find(opt => opt.field === notification.status);
        if (selectedReply) {
            statusDisplay = selectedReply.display;
        }
        const config = [
            { label: fields.Reference.label, value: notification.reference, },
            { resource: "GENERAL.FORMS.FIELD.STATUS", value: statusDisplay },
        ];
        if (notification.status !== 'Accepted') {
            const items = this.rejectOptions.filter(itm => (notification[itm.field] && notification[itm.field] === 1))
                .map(itm => ({ label: itm.display }))
            config.push({
                label: resources.ReplyNotificationClause + ' ' + this.props.intl.formatMessage({ id: 'CONTRACT.WF.PROGRAMME.REPLY.NOTE' }, { REFERENCE: notification.reference, STATUS: statusDisplay }),
                list: items,
                valueType: 'LIST',
                align: 'vertical'
            });
        }
        config.push(
            { resource: 'GENERAL.FORMS.FIELD.DETAILS', value: notification.comments, valueType: 'HTML', align: 'vertical' },
        )
        return config;
    }
    deleteProgramDraft = async (programid) => {

        try {
            await programCrud.deleteProgramDraft(programid);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_DELETED' }), { variant: 'success' });
            this.setState({ saving: false, navigateto: this.props.workflowItem.paths.listPath });

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ saving: false });
        }
    }
    saveProgramme = async (programme, action, notifyuserid) => {
        try {
            if (!programme.plannedcompletiondatedisplay && programme.plannedcompletiondate) {
                programme.plannedcompletiondatedisplay = moment(programme.plannedcompletiondate).format('DD/MM/YYYY');
            }
            if (!programme.previousplanneddatedisplay && programme.previousplanneddate) {
                programme.previousplanneddatedisplay = moment(programme.previousplanneddate).format('DD/MM/YYYY');
            }

            if (!programme.draftreplydatedisplay && programme.draftreplydate) {
                programme.draftreplydatedisplay = moment(programme.draftreplydate).format('DD/MM/YYYY');
            }

            if (!programme.replyrequireddatedisplay && programme.replyrequireddate) {
                programme.replyrequireddatedisplay = moment(programme.replyrequireddate).format('DD/MM/YYYY');
            }

            programme.actioncode = action;
            programme.notifyuserlist = this.getNotifyUserListForUpdate(action, notifyuserid);
            Common.PropertyConversionsBeforeNoticeSaveRequest(programme, this.props.customFields, this.props.contractUsers);
            await programCrud.updateProgram(programme);

            if (this.state.postActionUrl) {
                this.setState({ isChanged: false, saving: false, navigateto: this.state.postActionUrl.pathname });
            }
            else {
                this.fetchProgramme();

                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success', });

            }

        } catch (err) {
            this.setState({ saving: false });
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }

    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            if (field === "assetid") {
                this.setState({
                    notification: { ...this.state.notification, [field]: value, asset: { ...additionalData } },
                    isChanged: true
                });
            }
            else {
                this.state.notification[field] = value;
                if (!this.state.isChanged) {
                    this.setState({ isChanged: true });
                }
            }
        }

    }
    replyFieldChanged = (field, value, isDxReplyFormValid, isCheckBoxValue) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            this.state.reply[field] = value;
            if (!this.state.isChanged) {
                this.setState({ isChanged: true });
            }
        }

    }

    renderToolbar = (documentIsFinal) => {
        const saveDisabled = (this.state.saving || this.state.showModal || this.state.fileUploading);
        return (
            <PageToolbar
                key={this.state.notification.version}
                documentIsFinal={documentIsFinal}
                saveDisabled={saveDisabled}
                isAwaitingReply={this.state.isAwaitingReply}
                actions={{
                    showModal: this.showModal,
                    onPrintReply: this.printAcceptanceHandler,
                    onPrint: this.printHandler
                }}
                workflowItem={this.props.workflowItem}
                match={this.props.match}
                customFieldValues={this.state.notification.customfieldvalues}
                referenceid={this.state.notification.referenceid}
                contract={this.props.contract}
                relationParams={{
                    subject: this.getMailDescription(),
                    assetid: this.state.notification.assetid
                }}
                notification={this.state.notification}
                selectedClausetypeDisplay={this.getSelectedTypeClauseDisplay()}
            />
        );
    }
    tabDocument = () => {
        return (
            <ProgrammeDocument
                {...this.props}
                printDivRef={this.printIssueDivRef}
                fieldChanged={this.fieldChanged}
                notification={this.state.notification}
                files={this.state.files}

                onFilesCountChanged={(fCount) => { if (this.state.fileCount !== fCount) { this.setState({ fileCount: fCount }) } }}
                notificationid={this.props.params.notificationid}
                saving={this.state.saving}
                onFileUploadFinish={() => this.setState({ fileUploading: false })}
                onFileUploadStart={() => this.setState({ fileUploading: true })}
            />
        );
    }
    tabReply = () => {
        if (!this.props.workflowItem.userFilters.replyNotice.communicateReplyAllowed && !this.props.workflowItem.userFilters.replyNotice.saveDraftReplyAllowed && this.state.isAwaitingReply) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_AWAITING_REPLY" values={{ ITEM_NAME: this.props.workflowItem.pageTitle }} />
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else if (!this.state.isAwaitingReply && !this.state.notification.pdfreplyjsoncontent && this.state.notification.deemedacceptancedate) {
            //CEN HAS BEEN DEEM ACCEPTED
            //THERE IS NO REPLY DOCUMENT
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.ProgReplyMissingDueToDeemAcceptance}
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else {
            return (
                <ReplyDocument
                    {...this.props}
                    isAwaitingReply={this.state.isAwaitingReply}
                    printDivRef={this.printAcceptanceDivRef}
                    fieldChanged={this.replyFieldChanged}
                    notification={this.state.notification}
                    reply={this.state.reply}

                    files={this.state.replyFiles}
                    notificationid={this.props.params.notificationid}
                    saving={this.state.saving}
                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                />
            )
        }
    }
    tabRelations = () => {
        return (
            <Relations
                contractid={this.props.contract.contractid}
                workflowItem={this.props.workflowItem}
                workflowGroupItem={this.props.workflowGroupItem}
                notificationid={Number(this.props.params.notificationid)}
                relations={this.state.notification.relations}
                itemversion={this.state.notification.version}
                subject={this.state.notification.reference}
                onCountChange={(count) => this.setState({ relationCount: count })}
                showTags={this.props.contract.specifictags?.length > 0}
                assetid={this.state.notification.assetid}
            />
        );
    }
    tabEmailNotification = () => {

        return (
            <EmailNotifications
                {...this.props}
                notificationDate={this.state.notification.changeddate}
            />
        );

    };
    render() {
        if (!this.state.notification || !this.state.files || !this.state.replyFiles) {
            return (<PortletSpinner />);
        }
        const documentIsFinal = this.state.notification.showtasknotification === 1;
        const showReply = documentIsFinal && (this.state.notification.pdfreplyjsoncontent || this.state.notification.isreplyrequired);
        if (!documentIsFinal && !this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed) {
            return (<Navigate replace to={this.props.workflowItem.paths.listPath} />)
        }
        return (
            <Portlet>
                <ReactToPrint
                    ref={el => (this.printIssueRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printIssueDivRef.current}
                />
                <ReactToPrint
                    ref={el => (this.printAcceptanceRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printAcceptanceDivRef.current}
                />
                <NavigationBlocker
                    when={(this.state.isChanged || this.state.saving)}
                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
                />
                {this.state.navigateto &&
                    (
                        <Navigate replace to={this.state.navigateto} state={(this.state.postActionUrl || {}).state} />
                    )
                }
                <PortletHeader
                    title={documentIsFinal ? this.props.workflowItem.pageTitle : this.props.intl.formatMessage({ id: "GENERAL.FORMS.DRAFT_TITLE" }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                    toolbar={this.renderToolbar(documentIsFinal)}
                />
                <PortletBody>
                    <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                        <div>
                            <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                        </div>
                        <TabPanel
                            ref={(ref) => this.tabPanel = ref}
                            width="100%"
                            deferRendering={false}
                            animationEnabled={true}
                            focusStateEnabled={true}
                            hoverStateEnabled={true}
                            swipeEnabled={false}
                        >
                            <Item icon="file" title={this.props.title} render={this.tabDocument} />
                            <Item icon="rename" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_REPLY' })} render={showReply ? this.tabReply : null} visible={showReply} />

                            {
                                this.isRelationsEnabled && (
                                    <Item icon="share" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_RELATIONS' })} render={this.tabRelations} badge={this.state.relationCount > 0 ? this.state.relationCount : null} />
                                )
                            }
                            <Item
                                icon="bulletlist"
                                title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_EMAIL_NOTIFICATIONS' })}
                                render={documentIsFinal ? this.tabEmailNotification : null} visible={documentIsFinal}
                            />
                        </TabPanel>
                    </ValidationGroup>
                </PortletBody>
                <ActionModal
                    visible={this.state.showModal}
                    title={this.state.modalTitle}
                    text={this.state.modalText}
                    mode={this.state.modalMode}
                    onDialogResult={this.onModalResponse}
                    workflowItem={this.props.workflowItem}
                    selectedClause={this.state.selectedClause}
                    selectedReply={this.state.selectedReply}
                />
            </Portlet>
        );
    }
}


export default withDetailPageProps(ProgrammeDetail);
